// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"422":"my","826":"index"}[chunkId] + "." + {"422":"c98c71ed","826":"28121539"}[chunkId] + ".js";
};